/**
 * External dependencies
 */
import { find } from 'lodash';


let sections = null;

export function receiveSections( s ) {
    sections = s;
}

export function getSections() {
    if ( ! sections ) {
        throw new Error( 'sections-helper has not been initialized yet' );
    }
    return sections;
}

export function load( sectionName, moduleName ) {

    const section = find( sections, { name: sectionName, module: moduleName } );

    if ( ! section ) {
        return Promise.reject(
            `Attempting to load non-existent section: ${ sectionName } (module=${ moduleName })`
        );
    }
    
    let module = section.module;

    // currently no custom webpack loader
    return Promise.resolve( require("./modules/" + module) );
}